import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementRoutingModule } from './management.routing';
import { RouterModule } from '@angular/router';
import { GroupsComponent } from './groups/groups.component';
import { UsersComponent } from './users/users.component';
import { ManagementLayoutComponent } from './management-layout/management-layout.component';
import { HeaderSearchComponent } from './header-search/header-search.component';
import { ButtonComponent } from '../business-loan/button/button.component';



@NgModule({
    declarations: [GroupsComponent, UsersComponent, ManagementLayoutComponent, HeaderSearchComponent],
    imports: [
        CommonModule,
        ManagementRoutingModule,
        RouterModule,
        ButtonComponent,
    ]
})
export class ManagementModule { }
